"use client";

import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-5 w-32 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="max-w-full justify-start">
      <NavigationMenuList className="flex-col items-start gap-3 space-x-0">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full">
            <NavigationMenuLink asChild className="w-full justify-start px-0 py-1 h-auto font-sans text-secondary-foreground hover:bg-transparent hover:text-primary focus:bg-transparent focus:text-primary transition-colors">
              <Link to={item.href || "#"}>{item.label}</Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function SiteFooter() {
  const currentYear = new Date().getFullYear();
  return <section data-section-id="252997" id="footer" className="dark bg-background text-foreground pt-20 pb-10 px-6 md:px-12 border-t border-border relative overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-5 pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1672390/img/leaf_pattern_tile.png')] bg-repeat bg-[length:200px_200px]" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 lg:gap-8 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-primary" />
            </Link>
            <p className="text-muted-foreground font-default text-sm leading-relaxed mb-6">Portland Wellness Spa is a relaxed, professional spot in the heart of Portland where our staff get to work on what's bothering you. Come in tense, leave feeling better.</p>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground">Contact Us</h3>
            <ul className="flex flex-col gap-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground font-sans text-sm">
                <Phone className="w-5 h-5 text-chart-2 shrink-0 mt-0.5" />
                <span>(503) 890-9303</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground font-sans text-sm">
                <Mail className="w-5 h-5 text-chart-2 shrink-0 mt-0.5" />
                <span>portlandwellnessspallc@gmail.com</span>
              </li>
              <li className="flex items-start gap-3 text-muted-foreground font-sans text-sm">
                <MapPin className="w-5 h-5 text-chart-2 shrink-0 mt-0.5" />
                <span>8948 SW Barbur Blvd, Portland, OR 97219</span>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6 text-foreground">Links</h3>
            <MenuProvider menu_id="70">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        <div className="pt-8 border-t border-border flex flex-col lg:flex-row justify-between items-center gap-6">
          <p className="text-muted-foreground font-sans text-sm text-center lg:text-left">
            &copy; {currentYear} Portland Wellness Spa. All rights reserved.
          </p>
        </div>
      </div>
    </section>;
}